const mapSizes = [
  { width: 860, height: 250 },
  { width: 640, height: 250 },
  { width: 575, height: 185 },
  { width: 475, height: 185 },
  { width: 375, height: 185 },
  { width: 320, height: 185 },
  { width: 440, height: 274 }
];

export default mapSizes;
